module.exports = __webpack_public_path__ + "static/noman-s-ac81c20de98bbae5fbb30907548d8b9c.png";